import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

export default function (ComposedComponent) {
  class Authenticate extends React.Component {
    render() {
      return (
        <div>
          {this.props.isLoggedIn ? (
            <ComposedComponent {...this.props} />
          ) : (
            <Redirect to="/login" />
          )}
        </div>
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      isLoggedIn: state.loginReducer.isLoggedIn,
      isSuccesfull: state.signUpReducer.isSuccesfull,
    };
  };

  return connect(mapStateToProps)(Authenticate);
}
